import { isAbort, loadAchievements, loadNews, loadRosters } from '../data';
import { formatDate, loc, pluralize, t } from '../i18n';
import { $, emptyState, errorState, h, link, loadingState } from '../ui/dom';
import { newsCard, placeBadge, rosterRange } from '../ui/cards';

let controller: AbortController | null = null;

function stat(value: number | string, label: string): HTMLElement {
  return h('div', 'stat', h('b', null, String(value)), h('span', { class: 'mono', text: label }));
}

export function mountHome(): void {
  controller?.abort();
  controller = new AbortController();
  const signal = controller.signal;

  const newsEl = $('home-news');
  const rostersEl = $('home-rosters');
  const achEl = $('home-achievements');
  const statsEl = $('home-stats');
  newsEl?.replaceChildren(loadingState());
  rostersEl?.replaceChildren(loadingState());
  achEl?.replaceChildren(loadingState());

  const news = loadNews(signal);
  const rosters = loadRosters(signal);
  const achievements = loadAchievements(signal);

  news
    .then((items) => {
      if (signal.aborted || !newsEl) return;
      newsEl.replaceChildren(...(items.length ? items.slice(0, 3).map((n) => newsCard(n)) : [emptyState()]));
    })
    .catch((err) => {
      if (!isAbort(err)) newsEl?.replaceChildren(errorState(mountHome));
    });

  rosters
    .then((items) => {
      if (signal.aborted || !rostersEl) return;
      rostersEl.replaceChildren(
        ...items.map((r, i) =>
          link(
            `/roster#roster-${r.id}`,
            'roster-strip-item',
            h('span', 'mono rs-index', `0${i + 1}`),
            h('b', { text: r.name }),
            h('span', { class: 'mono rs-range', text: rosterRange(r) }),
            h('span', { class: 'rs-count', text: `${r.players.length} ${pluralize(r.players.length, t('roster.players'))}` }),
          ),
        ),
      );
      if (!items.length) rostersEl.replaceChildren(emptyState());
    })
    .catch((err) => {
      if (!isAbort(err)) rostersEl?.replaceChildren(errorState(mountHome));
    });

  achievements
    .then((items) => {
      if (signal.aborted || !achEl) return;
      achEl.replaceChildren(
        ...(items.length
          ? items.slice(0, 5).map((a) =>
              h(
                'div',
                'ach-mini-row',
                placeBadge(a.place),
                h('span', 'ach-mini-title', loc(a, 'title')),
                h('time', { class: 'mono', text: formatDate(a.event_date) }),
              ),
            )
          : [emptyState()]),
      );
    })
    .catch((err) => {
      if (!isAbort(err)) achEl?.replaceChildren(errorState(mountHome));
    });

  Promise.all([rosters, achievements])
    .then(([r, a]) => {
      if (signal.aborted || !statsEl) return;
      const players = r.reduce((sum, x) => sum + x.players.length, 0);
      statsEl.replaceChildren(
        stat(r.length, t('home.statRosters')),
        stat(players, t('home.statPlayers')),
        stat(a.length, t('home.statResults')),
      );
    })
    .catch(() => statsEl?.replaceChildren());
}

export function unmountHome(): void {
  controller?.abort();
  controller = null;
}
